import { useQuery } from '@apollo/client';

import { graphql } from '@eluve/graphql.tada';

const userSpecialtyFragment = graphql(`
  fragment UserSpecialtyFragment on Users @_unmask {
    __typename
    id
    specialty
  }
`);

const getUserSpecialtyQuery = graphql(
  `
    query getUserSpecialty($userId: uuid!) {
      usersByPk(id: $userId) {
        ...UserSpecialtyFragment
      }
    }
  `,
  [userSpecialtyFragment],
);

export const useUserSpecialty = (userId: string) => {
  const { data, loading } = useQuery(getUserSpecialtyQuery, {
    variables: { userId },
  });

  return {
    specialty: data?.usersByPk?.specialty ?? null,
    loading,
  };
};
